import createClient from '@economic/http-client';
import { AxiosInstance } from 'axios';

let hqApiEndpoint: string | undefined;
let api: AxiosInstance | null = null;

export function setupHqEndpoint(path: string) {
    hqApiEndpoint = `${path}/api`;
    api = createClient(
        hqApiEndpoint,
        `${process.env.ECONOMIC_PATH}/internal-api/application/access-token`,
        'Authorization',
        'Bearer ',
        60
    );
}

export default function getApi() {
    if (!api) {
        throw new Error('Call setupHqEndpoint before using the HQ API client');
    }

    return api;
}
